<template>
    <div class="news-subscribe" :style="`background-image: url(${result.picture.src})`">
        <h2 class="def-title-2">{{ result.messages.title }}</h2>
        <div class="news-subscribe__text" v-html="result.messages.text"></div>
        <div class="news-subscribe__form-wrapper">
            <div v-if="responseText !== '' " v-html="responseText" class="news-subscribe__response"></div>
            <form
                  :method="result.route.method"
                  :action="result.route.action"
                  class="news-subscribe__form def-validation"
                  @submit.prevent="handlerSubmit($event)"
            >
                <input type="hidden" name="action" value="subscribe">
                <input
                    :name="result.form.inputName"
                    type="text"
                    class="def-input def-email-mask"
                    required
                    :placeholder="result.messages.placeholder"
                    v-if="responseText === '' || badResponse"
                >
                <button v-if="responseText === '' || badResponse" type="submit" class="def-button">
                    {{ getWindowSize >= 768 ? result.messages.button.desktop : result.messages.button.mobile }}
                </button>
            </form>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NewsSubscribe',
        selector: '.news-subscribe',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "picture": {"src": "/local/templates/love-you/images/front-end/newsletter2.png"},
                    "route": {
                        "method": "post",
                        "action": "/ajax/",
                        "params-example-data": {
                            "mail": "some@mail.ua",
                            "action": "subscribe"
                        }
                    },
                    "messages": {
                        "title": "Новини від Love You",
                        "text": "Підпишіться на нашу розсилку, щоб першими дізнаватися про нові надходження, ексклюзивні акції та багато іншого",
                        "placeholder": "Email",
                        "button": {
                            "desktop": "Підписатись",
                            "mobile": "ок"
                        }
                    },
                    "form": {
                        "inputName": "mail"
                    }
                })
            }
        },
        data() {
            return {
                responseText: '',
                badResponse: false,
                //screenWidth: window.innerWidth
            }
        },
        methods: {
            getWindowSize() {
                return window.innerWidth;
            },
            handlerSubmit({target}) {
                try {
                    const formData = new FormData(target);
                    fetch(this.result.route.action, {
                        method: this.result.route.method,
                        body: formData
                    })
                        .then(res => res.json())
                        .then( ({response}) => {
                            if (response.status) {
                                this.responseText = response.text;
                            } else {
                                this.responseText = response.text;
                                this.badResponse = true;
                            }
                        });
                } catch (err) {
                    console.error(err);
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.getWindowSize.bind(this));
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowSize.bind(this));
        }
    }
</script>

<style lang="scss">
.news-subscribe {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    margin: 24px 0 56px;
    padding: 24px;
    @include point-md {
        height: 320px;
        margin: 32px 0 80px;
    }
    @include point-lg {
        height: 400px;
        margin: 56px 0 80px;
    }

    &__text {
        font-size: rem(16);
        text-align: center;
        color: var(--hyperlink-colour-secondary);
        //margin-bottom: 24px;
        max-width: 530px;
        @include point-md {
            font-size: rem(18);
            max-width: 380px;
        }
        @include point-lg {
            font-size: rem(24);
            margin-bottom: 30px;
            max-width: 530px;
        }
    }

    &__form {
        display: flex;
        margin-top: auto;
    }

    &__response{
        font-weight: 500;
        font-size: rem(18);
        text-align: center;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-colour-primary);
        margin-top: auto;
        @include point-lg{
            font-size: rem(24);
        }
    }
    &__form-wrapper{
        display: flex;
        flex-direction: column;
        min-height: 80px;
    }

    .def-title-2 {
        color: #467496;
        margin-bottom: 16px;
    }

    .def-input {
        display: block;
        height: 56px;
        color: #757575;
        font-size: rem(16);
        width: 205px;
        @include point-md {
            width: 234px;
        }
        @include point-lg {
            width: 300px;
        }

        &::placeholder {
            color: #757575;
            font-size: rem(16);
        }
    }

    .def-button {
        height: 56px;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        padding: 0 20px;
        @include point-lg {
            padding: 0 20px;
        }
    }
}
</style>